// THE EP BANNER — ink's <EpBanner> transcribed (parity, not distillation).
//
// PARADIGM SDK: when the exposure profile is paused, revoked, or no longer
// covers what the app declared, the app must say so plainly and offer re-auth.
// It is a permission boundary, not a bug, and it is the one condition a person
// cannot diagnose from the inside.
//
// WHAT IT FIXES HERE. Missions already learned about all of this — ep-events.js
// takes the webhook, /auth/status answers `epRevoked` with a `reauthUrl`, and
// /my-permissions carries `reauth` when a realm narrows below the DLR. None of
// it reached a surface. A revoked user fell to `authed: false` and got the
// LANDING PAGE, identical to never having signed in: no reason, no mention that
// the session had been working a moment ago, and the reauthUrl thrown away. The
// still-active-but-under-covered case was quieter still — an alarm dot on the
// Exposure tab of a wall nobody had open.
//
// And a GROUP that has not authorized Missions showed a raw 403 in the missions
// list, to someone whose own authorization was fine.
//
// And a session that ENDED under an open tab printed "not_authenticated" into
// whichever page had fetched, then left the person there.
//
// The wording lives in lib/epNotice.mjs so it can be tested; this file is the
// markup and nothing else.
import { epNotice } from '../lib/epNotice.mjs';
import './EpBanner.css';

export function EpBanner({ expired = false, revoked = false, reauth = null, reauthUrl = null, group = null }) {
  const notice = epNotice({ expired, revoked, reauth, reauthUrl, group });
  if (!notice) return null;
  return (
    <div className="ep-warning-banner" role="status" data-kind={notice.kind}>
      <span>{notice.message}</span>
      {notice.href && <a href={notice.href}>{notice.label}</a>}
    </div>
  );
}
